import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Grid from 'brandComponents/Grid';
import Typography from 'brandComponents/Typography';

import {IReturnInstructionsProps} from './IReturnInstructions';
import messages from './messages';
import {ReturnInstructionsItem} from './Subcomponents';

import styles from './ReturnInstructions.module.scss';

const ReturnInstructions = ({isZeroStep = false}: IReturnInstructionsProps) => {
	const intl = useIntl();

	return (
		<div className={styles['return-instructions']}>
			<Grid>
				<Grid.Row>
					<Grid.Column xs={12}>

						<div className={styles['return-instructions__container']}>
							<Typography classNames={styles['return-instructions__title']} variant="h3">
								{
									isZeroStep
										? intl.formatMessage(messages.zeroStepTitle)
										: intl.formatMessage(messages.whattodonext)
								}
							</Typography>
							<div
								className={cn(styles['return-instructions__steps'], {
									[styles['return-instructions__confirmation-step']]: !isZeroStep,
								})}
							>
								<ReturnInstructionsItem
									iconName="ran-step-1"
									title={intl.formatMessage(messages.title1)}
									description={intl.formatMessage(messages.description1)}
								/>
								<ReturnInstructionsItem
									iconName="ran-step-2"
									title={intl.formatMessage(messages.title2)}
									description={intl.formatMessage(messages.description2)}
								/>
								<ReturnInstructionsItem
									iconName="ran-step-3"
									title={intl.formatMessage(messages.title3)}
									description={intl.formatMessage(messages.description3)}
								/>
								<ReturnInstructionsItem
									iconName="ran-step-4"
									title={intl.formatMessage(messages.title4)}
									description={intl.formatMessage(messages.description4)}
								/>
								<ReturnInstructionsItem
									iconName="ran-step-5"
									title={intl.formatMessage(messages.title5)}
									description={intl.formatMessage(messages.description5)}
								/>
							</div>
						</div>

					</Grid.Column>
				</Grid.Row>
			</Grid>
		</div>
	);
};

export default ReturnInstructions;
